import {
  IContentSource
} from "../../../domain/drawing";
import {
  IHelpRepository,
  HelpFileInformation
} from "../../../domain/help";
import {
  AuthenticatedService,
} from "../..";
import { IHelpFileInformationBean } from "./beans";
import { HelpFileSource } from "./";

export class HelpRepository extends AuthenticatedService implements IHelpRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  private static toHelps(helps: IHelpFileInformationBean[]): HelpFileInformation[] {
    const results: HelpFileInformation[] = [];
    for (const help of helps) {
      results.push(HelpRepository.toHelp(help));
    }
    return results;
  }

  private static toHelp(bean: IHelpFileInformationBean): HelpFileInformation {
    return bean !== null
      ? Object.freeze(new HelpFileInformation(
          bean.id,
          bean.windowName,
          bean.name,
          bean.contents,
          bean.terminalName,
          bean.professionCode,
        ))
      : null;
  }

  async getFiles(windowName: string, terminalName: string, professionCode: string): Promise<HelpFileInformation[]> {
    if (!windowName || windowName === "") { throw new Error("windowName is empty!!!"); }
    const url = "/api/help/files";
    const result = await this.get(url, {
      params: {
        windowName,
        terminalName: terminalName ? terminalName : "",
        professionCode: professionCode ? professionCode : "",
      }
    });

    const bean = result.data as IHelpFileInformationBean[];
    return HelpRepository.toHelps(bean);
  }

  async getFile(fileId: number): Promise<IContentSource> {
    const source = new HelpFileSource(() => this.token, fileId);
    return source;
  }

  async getTerminalFiles(terminalName: string): Promise<HelpFileInformation[]> {
    const url = "/api/help/terminal/" + terminalName;
    const result = await this.get(url);

    const bean = result.data as IHelpFileInformationBean[];
    return HelpRepository.toHelps(bean);
  }

  async getProfessionFiles(professionCode: string): Promise<HelpFileInformation[]> {
    const url = "/api/help/profession/" + professionCode;
    const result = await this.get(url);

    const bean = result.data as IHelpFileInformationBean[];
    return HelpRepository.toHelps(bean);
  }

  async getSystemFiles(): Promise<HelpFileInformation[]> {
    const url = "/api/help/system";
    const result = await this.get(url);

    const bean = result.data as IHelpFileInformationBean[];
    return HelpRepository.toHelps(bean);
  }

  async getAllFiles(): Promise<HelpFileInformation[]> {
    const url = "/api/help/allfiles";
    const result = await this.get(url);

    const bean = result.data as IHelpFileInformationBean[];
    return HelpRepository.toHelps(bean);
  }

  async insertFile(windowName: string, fileName: string, contents: string, terminalName: string, professionCode: string): Promise<void> {
    const url = "/api/help/insert";
    const query = {
      windowName,
      name: fileName,
      contents,
      terminalName,
      professionCode,
    };
    await this.post<string>(url, query);
  }

  async updateFile(fileId: number, windowName: string, fileName: string, contents: string): Promise<void> {
    const url = "/api/help/update";
    const query = {
      id: fileId,
      windowName,
      name: fileName,
      contents,
    };
    await this.post<string>(url, query);
  }

  async deleteFile(fileId: number): Promise<void> {
    const url = "/api/help/delete";
    const query = {
      id: fileId,
    };
    await this.post<string>(url, query);
  }
}
